import { render, staticRenderFns } from "./ResellerLogin.vue?vue&type=template&id=03be2c84&scoped=true&"
import script from "./ResellerLogin.vue?vue&type=script&lang=js&"
export * from "./ResellerLogin.vue?vue&type=script&lang=js&"
import style0 from "./ResellerLogin.vue?vue&type=style&index=0&id=03be2c84&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03be2c84",
  null
  
)

export default component.exports